import {graphql, useLazyLoadQuery} from 'react-relay/hooks'
import {useParams} from 'react-router-dom'
import {Button, Grid, Hide, Stack} from '@chakra-ui/react'

import {ProviderIndexQuery} from './__generated__/ProviderIndexQuery.graphql'

import {GameList} from './components/GameList'
import {ProviderInfoCardSuspense} from '../components/ProviderInfoCard'
import {Heading} from 'components/Heading'
import {useSiteEnvironmentContext} from 'hooks'

export function ProviderIndex() {
  const {slug} = useParams()
  const {IS_YOUTH_DOMAIN, PICKUPHUB_YOUTH_URL} = useSiteEnvironmentContext()
  const {provider} = useLazyLoadQuery<ProviderIndexQuery>(
    graphql`
      query ProviderIndexQuery($slug: String!, $youth: Boolean!) {
        provider(slug: $slug) {
          ...GameList_provider_games @arguments(youth: $youth)
          youthGames: games(first: 1, times: [UPCOMING], youth: true)
            @skip(if: $youth) {
            pageInfo {
              total
            }
          }
        }
      }
    `,
    {slug, youth: IS_YOUTH_DOMAIN}
  )

  return (
    <Grid gap={4} p={4} templateColumns={[null, null, `1fr 1fr`]}>
      <Stack flex={1} spacing={4}>
        {provider.youthGames?.pageInfo.total > 0 && (
          <Button
            as="a"
            fontWeight="medium"
            href={`${PICKUPHUB_YOUTH_URL}/${slug}`}
            p={2}
            textAlign="center"
            textTransform="uppercase"
            colorScheme="purple"
            w="full"
          >
            View our Youth games
          </Button>
        )}

        <Heading>Upcoming {IS_YOUTH_DOMAIN && ` Youth`} Pickup Games</Heading>

        <GameList provider={provider} />
      </Stack>

      <Hide below="md">
        <ProviderInfoCardSuspense alignSelf="start" slug={slug} />
      </Hide>
    </Grid>
  )
}
